import React, { useContext, useMemo, useEffect, useState, useCallback } from 'react'
import styled, { ThemeContext } from 'styled-components'
import { Text } from 'rebass'
import { RouteComponentProps } from 'react-router-dom'
import { BigNumber } from 'bignumber.js'

import SortPets from '../Pet/components/SortPets'
import Row, {RowBetween} from '../../components/Row'
import Loading from '../../components/Loader/Loading'
import { ButtonLight } from '../../components/Button'
import NoMyArtwork from '../../components/Collection/NoMyArtwork'
import ArtworkCard from '../../components/Collection/ArtworkCard'
import StakeRowNew from '../../components/Gamification/StakeRowNew'
import ExchangeBakeVersion from '../../components/Gamification/ExchangeBakeVersion'

import useYam from '../../hooks/bakery/useYam'
import { useActiveWeb3React } from '../../hooks'
import useInterval from '../../hooks/useInterval'
import { CollectionArr } from '../../constants/nft'
import { NFTTYPE } from '../../constants/bakery/nft'
import { BIGNUMBER_FMT } from '../../constants/bakery'
import { useBakeLevel } from '../../state/bakePool/hooks'
import { userNftTypeNum } from '../../userType/userNftTypeNum'
import { userMarketType } from '../../userType/userMarketType'
import { userNftAddress } from '../../userType/userNftAddress'
import { contractAddresses } from '../../sushi/lib/constants'
import { userNFTContract } from '../../userType/userNFTContract'
import { getStakeType } from '../../userType/userGameNftTypeV1V2'
import { userV3NFTContract } from "../../userType/userV3NFTContract"
import { useWalletModalToggle } from '../../state/application/hooks'
import { userBidNFTContract } from '../../userType/userBidNFTContract'
import { userNFTMasterContract } from '../../userType/userNFTMasterContract'
import { userExchangeNFTContract } from "../../userType/userExchangeNFTContract"
import { multiTokenExchangeNftContract } from '../../userType/multiTokenExchangeNftContract'
import { MARKETTYPE, MARKETTYPEV1, MARKETTYPEV3, MARKETMULTITOKEN } from '../../constants/bakery/nft'
import { AuctionBake, SortOptions, PetSortOption, WeaponSortOption, ComboSortOption, TabOptions } from '../../constants/artwork'

import { getArtworksV3, getArtworks } from '../../service/nft'
import { getWeapons, getWeaponsV3 } from '../../service/weapon'
import { getPets, getPetsV3, getBakeryCombos, getBakeryCombosV3 } from '../../service/nft'
import { getPetEggs, getPetEggsV3 } from '../../service/pet'

import { getUserAsksByNFT, getUserBidsByNFT } from '../../sushi/exchangeNFTs'
import {
  getUserBids,
  getAsksByUser,
  getErc721Balance,
  getNftHelperContract,
  getCarBlindBoxAddress,
  getPokerBlindBoxAddress,
  getAllStakingBakerySoccer,
  getAllStakingPokerCard,
  commonStakeERC721EarnERC20GetUserInfo,
  commonStakeERC721EarnBakeGetUserInfo,
  getAllStakingCarNFTs,
  getBmoncNftBalance,
  getBmoncContract,
  getBmoncNFTContract
} from '../../sushi/utils'

const Wapper = styled.div`
  width: 100%;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    margin-top: 0px;
    text-align: center;
  `}
`
const MyArtworkWrapper = styled.div`
  max-width: 1184px;
  margin: 0 auto;
  position: relative;
  padding-left: 25px;
  padding-right: 25px;
`
const PendingBtn = styled.button`
  width: 172px;
  height: 40px;
  line-height: 40px;
  background: linear-gradient(to right, #FFD600, #FF7A00);
  -webkit-background-clip: text;
  color: transparent;
  font-size: 14px;
  border-radius: 50px;
  border: 1px solid #FF7A00;
  font-family: 'Roboto-Bold';
  cursor: pointer;
  margin-top: 48px;
  margin-bottom: 30px;
`
const ArtworkList = styled.div`
  display: grid;
  grid-row-gap: 20px;
  justify-content: space-between;
  grid-template-columns: repeat(auto-fill, 272px);
  ${({ theme }) => theme.mediaWidth.upToSmall`
    justify-content: center;
  `}
`
const UpToButtonLight = styled(ButtonLight)`
  margin-top: 160px;
  padding: 0px;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    margin-top: 80px;
  `}
`
const TopRow = styled(RowBetween)`
  flex-wrap: wrap;
  margin-bottom: 10px;
`
const LeftDiv = styled.div`

`
const RightDiv = styled.div`
  
`
export default function MyArtwork (
  {
    match: {params: {nftType}}
  } : RouteComponentProps<{ nftType: string}>
) {
  const sushi = useYam()
  const bakeLevel = useBakeLevel()
  const theme = useContext(ThemeContext)
  const nftHelper = getNftHelperContract(sushi)
  const { account, chainId } = useActiveWeb3React()
  // const account = "0xa5866c754e42679d152E4eB33cE1163215Ae1435"
  const toggleWalletModal = useWalletModalToggle()

  const [curStatus, setCurStatus] = useState(1)
  const [artworkList, setArtworkList] = useState<any>([])
  const [loadingFlag, setLoadingFlag] = useState(true)
  const level = ['v1', 'v2', 'v3']
  const exchangeNfts2Address = contractAddresses.exchangeNFTs2[chainId as number]
  
  const nftTypes = useMemo(() => {
    const [item] = CollectionArr.filter((d: any) => d.urlName === nftType)
    return item.nftType.split(',')
  }, [nftType])

  const stakeTypes = useMemo(() => {
    return CollectionArr.filter((d: any) => d.stake).map((item) => item.urlName)
  }, [CollectionArr])

  const pending = useCallback(async (status) => {
    setCurStatus(status)
  }, [setCurStatus])

  const filterSortOption = useMemo(() => {
    if (['pet', 'petEgg'].includes(nftType)) {
      return PetSortOption
    } else if (['weapon'].includes(nftType)) {
      return WeaponSortOption
    } else if (['combo'].includes(nftType)) {
      return ComboSortOption
    } else {
      return SortOptions.filter((d) => d.name !== 'Power')
    }
  }, [SortOptions, nftTypes])

  const [curSelect, setCurSelect] = useState(filterSortOption[0])
  const [curTab, setCurTab] = useState(TabOptions[0])
  const updateData = useCallback((d) => {
    setCurSelect(d)
  }, [])

  const upTab = useCallback((d) => {
    setCurTab(d)
  }, [])

  const getArtworkMethodsV1 = useMemo(() => {
    let methods
    switch (nftType) {
      case 'weapon':
        methods = getWeapons
        break;
      case 'pet':
        methods = getPets
        break
      case 'petEgg':
        methods = getPetEggs
        break
      case 'combo':
        methods = getBakeryCombos
        break
      default:
        methods = getArtworks
        break;
    }
    return methods
  }, [nftType])
  const getArtworkMethodsV3 = useMemo(() => {
    let methods
    switch (nftType) {
      case 'weapon':
        methods = getWeaponsV3
        break;
      case 'pet':
        methods = getPetsV3
        break
      case 'petEgg':
        methods = getPetEggsV3
        break
      case 'combo':
        methods = getBakeryCombosV3
        break
      default:
        methods = getArtworksV3
        break;
    }
    return methods
  }, [nftType])

  const getDataV1 = useCallback((params: any) => {
    return new Promise((resolve, reject) => {
      getArtworkMethodsV1(chainId as number, params, (err: any, data: any) => {
        if (err) {
          reject()
          return
        }
        if (data.code !== 0) {
          reject()
          return
        }
        const dataAry = data.data.list || []
        dataAry.forEach((d: any) => {
          d.nftLevel = 'v1'
        })
        resolve(dataAry)
      })
    })
    .catch(() => [])
    .finally(() => {
      setLoadingFlag(false)
    })
  }, [])
  const getDataV3 = useCallback((params: any) => {
    return new Promise((resolve, reject) => {
      getArtworkMethodsV3(chainId as number, params, (err: any, data: any) => {
        if (err) {
          reject()
          return
        }
        if (data.code !== 0) {
          reject()
          return
        }
        const dataAry = data.data.list || []
        resolve(dataAry)
      })
    })
    .catch(() => [])
    .finally(() => {
      setLoadingFlag(false)
    })
  }, [])

  const getAllBoxId = useCallback(async() => {
    let balanceArr: any = []
    const nftHelper = getNftHelperContract(sushi)

    let nftType: any
    let fileUrl: any
    let boxName: any
    let boxAddress: any
    if (nftTypes.includes('106')) {
      nftType = '106'
      fileUrl = "/images/nft/blindbox.svg"
      boxName = 'PET BlindBox'
      boxAddress = getPokerBlindBoxAddress(sushi)
    } else if (nftTypes.includes('103')) {
      nftType = '103'
      boxName = 'Rare Car Box'
      fileUrl = "/images/nft/carbox.png"
      boxAddress = getCarBlindBoxAddress(sushi)
    }
    if (!boxAddress) return []
    balanceArr = await getErc721Balance(nftHelper, boxAddress, account)
    const boxs = balanceArr.map((d: any) => {
      return {
        isBlindbox: true,
        nftType: nftType,
        tokenId: d,
        id: nftType + '-' + d,
        fileUrl: fileUrl,
        minImage: fileUrl,
        boxName: boxName,
        attributes: {
          stakingPower: 0
        }
      }
    })
    if (!boxs) return
    return boxs
  }, [account, sushi])

  const getAllArtworks = async () => {
    const lastList = {
      'v1': [],
      'v2': [],
      'v3': []
    }
    await Promise.all(
      level.map(async(v) => {
        await Promise.all(
          nftTypes.map(async(nftType: string) => {
            const marketType = userMarketType(nftType, v)
            const nftAddress = marketType && userNftAddress(sushi, marketType)
      
            let stakeType: any = []
            let stakeList: any = []
            if (v === 'v3') {
              if (nftType === '108') {
                stakeType = [NFTTYPE.BARKING, NFTTYPE.BARKING_V2, NFTTYPE.BARKING_V3]
              } else if (nftType === '117') {
                stakeType = [NFTTYPE.BAKEMUSKMIXER, NFTTYPE.BAKEMUSKMIXER_V2, NFTTYPE.BAKEMUSKMIXER_V3]
              } else if (nftType === '106') {
                stakeType = [NFTTYPE.POKER, NFTTYPE.POKER_V2, NFTTYPE.POKER_V3]
              } else if (nftType === '103') {
                stakeType = [NFTTYPE.CAR, NFTTYPE.CAR_V2,, NFTTYPE.CAR_V3]
              } else if (nftType === '100') {
                stakeType = [NFTTYPE.SOCCER, NFTTYPE.SOCCER_V2, NFTTYPE.SOCCER_V3]
              } else if (nftType === '104') {
                stakeType = [NFTTYPE.DOGGIES, NFTTYPE.DOGGIES_V2, NFTTYPE.DOGGIES_V3]
              } else if (nftType === '114') {
                stakeType = [NFTTYPE.EQUIPMENT, NFTTYPE.EQUIPMENT_V2, NFTTYPE.EQUIPMENT_V3]
              } else if (nftType === 'combo') {
                stakeType = [NFTTYPE.COMBO, NFTTYPE.COMBO_V2, NFTTYPE.COMBO_V3]
              }
            }

            stakeType.forEach(async(d: any) => {
              const list = await getUserStakes(d)
              stakeList.push(...list, ...stakeList)
            })

            const askList = await getUserAsks(marketType)
            const bidList = await getUserBid(marketType)

            let wattleList: any[] = []
            if(marketType === MARKETTYPEV3.BINAMONV3 && chainId && chainId === 56){
              // 查询BmoncNFT余额
              wattleList = await getBmoncNftBalance(getBmoncContract(sushi), getBmoncNFTContract(sushi), account)
            }else{
              wattleList = v === 'v3' ? await getErc721Balance(nftHelper, nftAddress, account) : []
            }

            const listSet = new Set()
            wattleList.forEach((d: any) => {
              listSet.add(d.toString())
            })
            askList.forEach((d: any) => {
              listSet.add(d[0].toString())
            })
            bidList.forEach((d: any) => {
              listSet.add(d[0].toString())
            })
            stakeList.forEach((d: any) => {
              listSet.add(d.toString())
            })

            const newArr = Array.from(listSet).map((item) => {
              if (['weapon', 'pet', 'petEgg', 'combo'].includes(nftType)) {
                return item
              } else {
                return `${nftType}-${item}`
              }
            })
            lastList[v] = [...newArr.sort(), ...lastList[v]]
          })
        )
      })
    )

    const blindBoxs = await getAllBoxId()

    if (lastList.v1.length || lastList.v2.length || lastList.v3.length) {
      fetchList(lastList, blindBoxs)
    } else {
      if (blindBoxs.length) {
        setLoadingFlag(false)
        setArtworkList(blindBoxs)
      } else {
        setLoadingFlag(false)
        setArtworkList([])
      }
    }
  }

  const fetchList = async(listId: any, boxId?: []) => {
    const idsV1 = listId.v1.join(',')
    const idsV2V3 = [...listId.v2, ...listId.v3].join(',')

    let params = {
      onSale: -3,
      sortBy: curSelect.sortBy,
      sortName: curSelect.sortName,
      fileType: +curTab.sortName,
      status: curStatus
    }

    const paramsV1 = {
      ...params,
      ids: idsV1
    }
    const paramsV2V3 = {
      ...params,
      ids: idsV2V3
    }

    let listV1
    let listV2V3

    if (idsV1) {
      listV1 = await getDataV1(paramsV1)
    } else {
      listV1 = []
    }

    if (idsV2V3) {
      listV2V3 = await getDataV3(paramsV2V3)
      console.log("--listV2V3--",listV2V3)
    } else {
      listV2V3 = []
    }

    const handleDataArtworks = (arr: any) => {
      const artworks = arr.map((d: any) => {
        let level = (((d.auctionPrice && Number(d.auctionPrice)) && (d.price && Number(d.price) && +d.price === AuctionBake))
            || (d.price && Number(d.price))
            || ((d.auctionPrice && Number(d.auctionPrice)) && !Number(d.price) && (d.owner !== account))) &&  d.exchangeAddress?.toLowerCase() !== exchangeNfts2Address.toLowerCase() ? 'v2' : 'v3'
        return {
          ...d,
          nftLevel: d.nftLevel || level,
          tokenId: d.nftId || d.id,
          status: d.status !== undefined ? d.status : 1,
          nftType: d.nftType ? String(d.nftType) : nftType,
          maxBidPrice: (d.maxBidPrice && !Number(d.maxBidPrice)) && (d.auctionPrice && Number(d.auctionPrice)) ? d.auctionPrice.toString() : d.maxBidPrice,
          ...((d.price && Number(d.price)) ? {price: d.price.toString()} : {price: ''}),
          ...((d.auctionPrice && Number(d.auctionPrice)) && (d.price && Number(d.price) && +d.price === AuctionBake) ? {auctionPrice: d.auctionPrice.toString()} : {auctionPrice: ''})
        }
      })
      return artworks
    }

    const artworksV1 = handleDataArtworks(listV1)
    const artworksV2V3 = handleDataArtworks(listV2V3)
    setLoadingFlag(false)
    setArtworkList([...boxId, ...artworksV2V3, ...artworksV1])
  }

  const getUserAsks = useCallback(async(type) => {
    try {
      let userAsks: any[] = []
      let exchangeNFTContract: any
      let isMultiToken:boolean = false
  
      if(type && MARKETTYPE.hasOwnProperty(type)){
        exchangeNFTContract = userBidNFTContract(sushi, type)
        isMultiToken = false
      }else if(type && MARKETMULTITOKEN.hasOwnProperty(type)){
        exchangeNFTContract = multiTokenExchangeNftContract(sushi, type)
        isMultiToken = true
      }else if(type && MARKETTYPEV1.hasOwnProperty(type)){
        exchangeNFTContract = userExchangeNFTContract(sushi, type)
      }else if(type && MARKETTYPEV3.hasOwnProperty(type)){
        exchangeNFTContract = userV3NFTContract(sushi, type)
        isMultiToken = true
      }
      if(!isMultiToken) {
        userAsks = await getAsksByUser(exchangeNFTContract, account)
      }else {
        if(type && MARKETMULTITOKEN.hasOwnProperty(type) || (type && MARKETTYPEV3.hasOwnProperty(type))){
          let nftAddress = userNftAddress(sushi, type)
          let curTokenAsks = await getUserAsksByNFT(exchangeNFTContract, nftAddress, account)
          userAsks = curTokenAsks.map((d: any) => {
            return [
              d.tokenId,
              d.price
            ]
          })
        }
      }
      return userAsks
    } catch (e) {
      return []
    }
  }, [account, sushi])

  const getUserBid = useCallback(async(type) => {
    const typeArray = type?.split(",")
    const exchangeNFTContractArray: any = typeArray?.map((d:any) => {
      let exchangeNFTContract: any
      let isMultiToken:boolean = false
      if(d && MARKETTYPE.hasOwnProperty(d)){
        exchangeNFTContract = userBidNFTContract(sushi, d)
        isMultiToken = false
      }else if(d && MARKETMULTITOKEN.hasOwnProperty(d)){
        exchangeNFTContract = multiTokenExchangeNftContract(sushi, d)
        isMultiToken = true
      }else if(d && MARKETTYPEV1.hasOwnProperty(d)){
        exchangeNFTContract = userExchangeNFTContract(sushi, d)
      }else if(d && MARKETTYPEV3.hasOwnProperty(d)){
        exchangeNFTContract = userV3NFTContract(sushi, d)
        isMultiToken = true
      }
      return {
        exchangeNFTContract: exchangeNFTContract,
        isMultiToken: isMultiToken,
        type: d
      }
    })

    try {
      let userBidsMultiType: any[] = []
      for(let i = 0;i < exchangeNFTContractArray.length;i++){
        let userBids: any[] = []
        if(!exchangeNFTContractArray[i].isMultiToken) {
          userBids = await getUserBids(exchangeNFTContractArray[i].exchangeNFTContract, account)
        }else {
          if(exchangeNFTContractArray[i].type && MARKETMULTITOKEN.hasOwnProperty(exchangeNFTContractArray[i].type) || (exchangeNFTContractArray[i].type && MARKETTYPEV3.hasOwnProperty(exchangeNFTContractArray[i].type))){
            let nftAddress = userNftAddress(sushi, exchangeNFTContractArray[i].type)
            let nftType = userNftTypeNum(exchangeNFTContractArray[i].type)
            let curTokenBids = await getUserBidsByNFT(exchangeNFTContractArray[i].exchangeNFTContract, nftAddress, account)
            userBids = curTokenBids.map((d: any) => {
              return [
                d.tokenId,
                d.price,
                d.quote,
                nftType
              ]
            })
          }
        }
        userBidsMultiType = [...userBidsMultiType, ...userBids]
      }
      return userBidsMultiType
    } catch (e) {
      return []
    }
  }, [account, sushi])

  const getUserStakes = useCallback(async(type) => {
    if (!type) return []
    try {
      let exchangeNFTContract: any = userNFTMasterContract(sushi, type)
      let exchangeContract: any = userNFTContract(sushi, type)
      let userBids: any
      if(type && [NFTTYPE.SOCCER].includes(type)){
        userBids = await getAllStakingBakerySoccer(exchangeNFTContract, account)
      }else if(type && [NFTTYPE.POKER].includes(type)){
        let Arr = await getAllStakingPokerCard(exchangeNFTContract, exchangeContract, account)
        userBids = Arr.map((d: any) => {
          return d.tokenId
        })
      }else if(type && [NFTTYPE.GAMEBOX].includes(type)){
        let Arr = await commonStakeERC721EarnERC20GetUserInfo(exchangeNFTContract, exchangeContract, account)
        userBids = Arr[2]
      }else if(type && [NFTTYPE.CAR].includes(type)){
        let Arr = await getAllStakingCarNFTs(exchangeNFTContract, exchangeContract, account)
        userBids = Arr.map((d: any) => {
          return d.tokenId
        })
      }else if(type && [
        NFTTYPE.CAR_V2,
        NFTTYPE.DOGGIES, 
        NFTTYPE.DOGGIES_V2,
        NFTTYPE.BARKING,
        NFTTYPE.BARKING_V2,
        NFTTYPE.MATRIX,
        NFTTYPE.POKER_V2,
        NFTTYPE.EQUIPMENT,
        NFTTYPE.EQUIPMENT_V2,
        NFTTYPE.BAKEMUSKMIXER,
        NFTTYPE.BAKEMUSKMIXER_V2,
        NFTTYPE.SOCCER_V2,
        NFTTYPE.COMBO_V2,
        NFTTYPE.DOGGIES_V3,
        NFTTYPE.BARKING_V3,
        NFTTYPE.EQUIPMENT_V3,
        NFTTYPE.BAKEMUSKMIXER_V3,
        NFTTYPE.CAR_V3,
        NFTTYPE.COMBO_V3,
        NFTTYPE.SOCCER_V3,
        NFTTYPE.POKER_V3, 
      ].includes(type)){
        let Arr = await commonStakeERC721EarnBakeGetUserInfo(exchangeNFTContract, account)
        userBids =[...Arr[2]]
      }
      const list = userBids.map((d: any) => {
        return d
      })
      return list
    } catch (e) {
      console.log(e)
      return []
    }
  }, [account])

  const stakeType = getStakeType(nftTypes.includes('107') ? '117' : nftTypes[0], bakeLevel)

  useEffect(() => {
    getAllArtworks()
  }, [nftTypes, curStatus, curSelect, curTab])

  useInterval(getAllArtworks, (stakeTypes.includes(nftType) && account) ? 10000 : null)

  return(
    <>
      <Loading open={loadingFlag} />
      {
        !account ? (
          <UpToButtonLight width={'180px'} height={40} onClick={toggleWalletModal}>
            Connect Wallet
          </UpToButtonLight>
        ) : 
        <Wapper>
          <MyArtworkWrapper>
            <TopRow>
              <LeftDiv>
                <Text fontSize={40} color={theme.text6} fontFamily={'Roboto-Bold'}>My Artworks</Text>
                <Text color={theme.text6}>Your wonderful artworks are here!</Text>
                <PendingBtn onClick={() => {pending(curStatus === 0 ? 1 : 0)}}>Pending</PendingBtn>
              </LeftDiv>
              {
                stakeTypes.includes(nftType) ?
                  <RightDiv>
                    <ExchangeBakeVersion></ExchangeBakeVersion>
                    <StakeRowNew type={stakeType}></StakeRowNew>
                  </RightDiv>
                : null
              }
            </TopRow>
            <Row justifyContent='flex-end'>
              <SortPets
                bg={theme.bsBg30}
                height={32}
                margin="0 15"
                curSelect={curTab}
                options={TabOptions}
                updateData={upTab}
              ></SortPets>
              <SortPets
                wd='110px'
                height={32}
                bg={theme.bsBg30}
                curSelect={curSelect}
                options={filterSortOption}
                updateData={updateData}
              ></SortPets>
            </Row>
            <Row paddingTop={'7px'} marginBottom={'15px'}>
              <Text fontSize={16} color={theme.text6} fontFamily={'Roboto-Bold'}>{ new BigNumber(artworkList.length).integerValue(BigNumber.ROUND_CEIL).toFormat(0, BIGNUMBER_FMT)}</Text>
              <Text color={theme.bsText3} marginLeft={'5px'}>Items</Text>
            </Row>
            {
              artworkList.length ?
                <ArtworkList>
                  {
                    artworkList.map((d: any) => {
                      return (
                        <ArtworkCard key={d.id} artwork={d}></ArtworkCard>
                      )
                    })
                  }
                </ArtworkList>
              : !loadingFlag && <NoMyArtwork></NoMyArtwork>
            }
          </MyArtworkWrapper>
        </Wapper>
      }
    </>
  )
}